export const categoriasAgendamento = {
    HABILITACAO: 1,
    VEICULO: 2,
    MULTA: 3,
    FOTO_DIGITAL: 4,
    PROCESSO: 5,
    RETIRADA_DOCUMENTOS: 6
}